/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const authorizationResponseSchema = z.object({
  oauthCredentialsId: z.int(),
  returnUrl: z.string().nullish(),
});
